import { LitElement, css, html } from "lit";

export class CzLoader extends LitElement {
	static styles = css`
		@layer component {
			:host {
				--_cz-loader-color: var(--cz-loader-color, currentcolor);
				--_cz-loader-width: var(--cz-loader-width, 50px);
				--_cz-loader-height: var(--cz-loader-height, 50px);

				display: block;

				max-width: var(--_cz-loader-width);
				max-height: var(--_cz-loader-height);
				stroke: var(--_cz-loader-color);
			}
		}
	`;

	static properties = {
		text: {type: String},
	};

	constructor() {
		super();
		this.text = 'loading...';
	}

	render() {
		return html`<svg aria-valuetext="${this.text}" role="progressbar" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
			<circle cx="50" cy="50" fill="none" r="40" stroke-opacity="0.5" stroke-width="10"></circle>
			<circle cx="50" cy="50" fill="none" r="40" stroke-linecap="round" stroke-opacity="0.8" stroke-width="10">
				<animateTransform attributeName="transform" dur="1.7" keyTimes="0;0.5;1" repeatCount="indefinite" type="rotate" values="0 50 50;180 50 50;720 50 50"></animateTransform>
				<animate attributeName="stroke-dasharray" dur="1.7" keyTimes="0;0.5;1" repeatCount="indefinite" values="40 170;140 70;40 170"></animate>
			</circle>
		</svg>`;
	}
}

if (!customElements.get('cz-loader')) {
	customElements.define('cz-loader', CzLoader);
}